import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {Outlet, Route, Routes, useNavigate} from 'react-router-dom'
import {useAuth} from '../../_component/modules/auth'
import TabMenu from './components/ChargeTabMenu'
import {ChargeSettings} from './setting/ChargeSettings'

const ChargePageTest = () => {
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const navigate = useNavigate()
  const {logout} = useAuth()

  useEffect(() => {
    if (
      !userInfo ||
      !['sys_admin', 'sys_user', 'charge_user', 'gov_charge'].includes(userInfo.accountType)
    ) {
      logout()
      navigate('/auth')
    }
  }, [userInfo, logout])

  useEffect(() => {
    document.body.setAttribute('data-kt-aside-minimize', 'on')
  }, [])

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='info'
          element={
            <>
              {/* <DataTable /> */}
              <TabMenu />
            </>
          }
        />
        <Route path='setting' element={<ChargeSettings />} />
      </Route>
    </Routes>
  )
}

export default ChargePageTest
